import React, { cloneElement, Fragment } from "react";
import { useDispatch } from "react-redux";
import { changeQuestionAction } from "../../../../redux/answeringQuestions/answeringQuestions";

const QuestionListController = ( props ) => {

  const dispatch = useDispatch();
  const changeQuestion = payload => { dispatch( changeQuestionAction( payload ) ) };

  const change = ( event ) => {
    changeQuestion( event.target.value );
  };

  return cloneElement( props.children || <Fragment />, {
    onChange : change
  } );

};

export default QuestionListController;
